<template>
  <v-container class="content-container">

    <v-row justify="space-between">

        <v-col class="">

            <div>

                <!-- Ostali trgovci (non avtobroker) -->
                <div class="panel panel--info" v-if="appStore.User.AvtoBroker == false">
                    <div class="panel__title mb-5">
                        Kaj stranka potrebuje?
                    </div>

                    <div class="d-flex align-center">
                        <!-- <img src="../../assets/images/dashboard/dec22/icon-info.svg" alt="Icon coins" class="mr-5"> -->
                        <div>
                            <div class="panel__subtitle">Zaposleni v Sloveniji in upokojenec</div>
                            
                        </div>
                    </div>

                    <div class="text-md ml-md-15">
                        <div class="ml-md-8 mt-5 mt-md-0 mb-2">Do 3.000 € potrebuje samo:</div>
                        <ul class="ml-8 ml-md-15">
                            <li>Osebni dokument</li>
                            <li>Davčno številko</li>
                            <li>Številko transakcijskega računa</li>
                            <li>Mobilno telefonsko številko</li>
                        </ul>
                    </div>

                    <div class="panel__title mt-10 mb-3">
                        Primeri, ko stranka potrebuje dodatno dokumentacijo
                    </div>

                    <div class="text-md ml-md-15">
                        <ul class="ml-8 ml-md-15">
                            <li>Presežen limit 3.000 €</li>
                            <li>Daljša ročnost, nad 36 mesecev</li>
                            <li>Mlajši od 25 let</li>
                            <li>Zasebnik, tuj državljan, zaposlen v tujini in ostalo</li>
                        </ul>
                    </div>

                    <div class="d-flex align-center mt-5 mb-5">
                        <!-- <img src="../../assets/images/dashboard/dec22/icon-info.svg" alt="Icon coins" class="mr-5"> -->
                        <div>
                            <div class="panel__subtitle">Dodatna dokumentacija</div>
                        </div>
                    </div>

                    <div class="text-md ml-md-15">
                        <div class="ml-md-8">
                            <div class="mb-3 font-weight-medium">Zaposleni</div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <div class="">Zadnji bančni izpisek (v primeru, da iz izpiska ni razvidno, da gre za nakazilo plače, se priloži še ujemajoča plačilna lista)</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Zasebnik</div>
                            <div class="d-flex align-center mb-5">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon document" class="mr-5"> -->
                                <div>
                                    <div class="">Bančni izpisek za 3 mesece</div>
                                </div>
                            </div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-1-leto.svg" alt="Icon 1" class="mr-5"> -->
                                <div>
                                    <div class="">Posluje najmanj eno leto</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Upokojenec</div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <div class="">Zadnji bančni izpisek</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Upokojenec - prejemnik tuje pokojnine/rente</div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <div class="">Zadnji bančni izpisek in odločba o prejemanju tuje pokojnine/rente</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Oseba na porodniškem dopustu</div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <div class="">Zadnji bančni izpisek in potrdilo slovenskega delodajalca o zaposlitvi</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Tuj državljan</div>
                            <div class="d-flex align-start">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <ul class="ml-5">
                                        <li>Zadnji bančni izpisek,</li>
                                        <li>plačilna lista,</li>
                                        <li>potrdilo o prijavi stalnega prebivališča v RS in</li>
                                        <li>potrdilo delodajalca/pogodba o zaposlitvi.</li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="text-center">
                        <v-btn @click="appStore.BackToDashboard()" flat size="large" class="btn btn-pure-pink mt-15">Nazaj domov</v-btn>
                    </div>

                </div>

                <!-- Avtobroker -->
                <div class="panel panel--info" v-else>
                    <div class="panel__title mb-5">
                        Kaj stranka potrebuje?
                    </div>

                    <div class="d-flex align-center">
                        <!-- <img src="../../assets/images/dashboard/dec22/icon-info.svg" alt="Icon coins" class="mr-5"> -->
                        <div>
                            <div class="panel__subtitle">Zaposleni v Sloveniji in upokojenec</div>
                            
                        </div>
                    </div>

                    <div class="text-md ml-md-15">
                        <div class="ml-md-8 mt-5 mt-md-0 mb-2">Do 3.000 € potrebuje samo:</div>
                        <ul class="ml-8 ml-md-15">
                            <li>Osebni dokument</li>
                            <li>Davčno številko</li>
                            <li>Številko transakcijskega računa</li>
                            <li>Mobilno telefonsko številko</li>
                        </ul>
                    </div>

                    <div class="panel__title mt-10 mb-3">
                        Primeri, ko stranka potrebuje dodatno dokumentacijo
                    </div>

                    <div class="text-md ml-md-15">
                        <ul class="ml-8 ml-md-15">
                            <li>Presežen limit 3.000 €</li>
                            <li>Daljša ročnost, nad 36 mesecev</li>
                            <li>Mlajši od 25 let</li>
                            <li>Zasebnik, tuj državljan, zaposlen v tujini in ostalo</li>
                        </ul>
                    </div>

                    <div class="d-flex align-center mt-5 mb-5">
                        <!-- <img src="../../assets/images/dashboard/dec22/icon-info.svg" alt="Icon coins" class="mr-5"> -->
                        <div>
                            <div class="panel__subtitle">Dodatna dokumentacija</div>
                        </div>
                    </div>

                    <div class="text-md ml-md-15">
                        <div class="ml-md-8">
                            <div class="mb-3 font-weight-medium">Zaposleni</div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <div class="">Zadnji bančni izpisek (v primeru, da iz izpiska ni razvidno, da gre za nakazilo plače, se priloži še ujemajoča plačilna lista)</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Zasebnik</div>
                            <div class="d-flex align-center mb-5">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon document" class="mr-5"> -->
                                <div>
                                    <div class="">Bančni izpisek za 3 mesece</div>
                                </div>
                            </div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-1-leto.svg" alt="Icon 1" class="mr-5"> -->
                                <div>
                                    <div class="">Posluje najmanj eno leto</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Upokojenec</div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <div class="">Zadnji bančni izpisek</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Upokojenec - prejemnik tuje pokojnine/rente</div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <div class="">Zadnji bančni izpisek in odločba o prejemanju tuje pokojnine/rente</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Oseba na porodniškem dopustu</div>
                            <div class="d-flex align-center mb-8">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <div class="">Zadnji bančni izpisek in potrdilo slovenskega delodajalca o zaposlitvi</div>
                                </div>
                            </div>

                            <div class="mb-3 font-weight-medium">Tuj državljan</div>
                            <div class="d-flex align-start">
                                <!-- <img src="../../assets/images/dashboard/dec22/icon-dokumentacija.png" alt="Icon coins" class="mr-5"> -->
                                <div>
                                    <ul class="ml-5">
                                        <li>Zadnji bančni izpisek,</li>
                                        <li>plačilna lista,</li>
                                        <li>potrdilo o prijavi stalnega prebivališča v RS in</li>
                                        <li>potrdilo delodajalca/pogodba o zaposlitvi.</li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="panel__title mt-10">
                        Kopija prometnega dovoljenja in računa je pogoj za plačilo pogodbe za nakup na obroke.
                    </div>

                    <div class="text-center">
                        <v-btn @click="appStore.BackToDashboard()" flat size="large" class="btn btn-pure-pink mt-15">Nazaj domov</v-btn>
                    </div>

                </div>

            </div>

        </v-col>

    </v-row>

  </v-container>
</template>


<script setup lang="ts">
    import router from "@app/router";
    import { useAppStore } from "@/app/store/app/store";

    const appStore = useAppStore();
</script>

